<script>
import { Dropdown } from 'vue-bootstrap';

/**
 * The ListFieldPairings component.
 */
export default {
  components: {
    Dropdown
  }
};
</script>
